module.exports = __webpack_public_path__ + "static/media/image 59.55b1173b.webp";